import { createGlobalStyle } from 'styled-components';
import { token } from '../sections/renewalStyles';

/**
 * 리뉴얼 전역 스타일.
 * styled-reset <Reset /> 뒤에 렌더해서 리셋 이후의 값이 적용되도록 합니다.
 */
const GlobalStyle = createGlobalStyle`
  html {
    scroll-behavior: smooth;
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    color: ${token.ink};
    background: #fff;
    letter-spacing: -0.02em;
    line-height: normal;
    -webkit-font-smoothing: antialiased;
  }

  a {
    color: ${token.primary};
    text-decoration: none;
  }

  a:hover {
    color: ${token.primaryDeep};
    text-decoration: underline;
  }

  :focus-visible {
    outline: 2px solid ${token.primary};
    outline-offset: 2px;
  }

  @keyframes brit-marquee {
    from { transform: translateX(0); }
    to { transform: translateX(-50%); }
  }

  @keyframes brit-bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(6px); }
  }

  /* 스크롤 리빌 — IntersectionObserver 가 is-in 을 붙입니다. */
  [data-reveal] {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity .7s ${token.ease}, transform .7s ${token.ease};
  }

  [data-reveal].is-in {
    opacity: 1;
    transform: none;
  }

  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    * { animation: none !important; transition: none !important; }
    [data-reveal] { opacity: 1 !important; transform: none !important; }
  }
`;

export default GlobalStyle;
